import Vue from 'vue'
import BasicModel from '@/framework/basic/BasicModel'

Vue.directive('confirm-input', {
  bind: function (el, binding, vnode) {
    let _this = vnode.context
    let componentInstance = vnode.componentInstance
    let data = componentInstance.$attrs['confirm-input-data']
    el.onclick = function (e) {
      let confirmInputText = componentInstance.$attrs['confirm-input-text']
      let confirmInputPlaceholder = componentInstance.$attrs['confirm-input-placeholder']
      let confirmInputType = componentInstance.$attrs['confirm-input-type'] ? componentInstance.$attrs['confirm-input-type'] : 'text'
      const h = _this.$createElement

      let content = componentInstance.$attrs['confirm-inner-content']

      let input = null
      if (content == null) {
        input = h('input',
          {
            attrs: {
              class: 'el-input__inner',
              type: confirmInputType,
              placeholder: confirmInputPlaceholder || '请输入内容'
            }
          })
        content = [
          input
        ]
      } else {
        input = content[0]
      }

      _this.$msgbox({
        title: confirmInputText || '确认进行此操作？',
        message: h('div', null, content),
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose (action, instance, done) {
          if (action === 'confirm') {
            let valueNoRequired = componentInstance.$attrs['value-no-required']
            let value = input.elm.value
            if (valueNoRequired) {

            } else {
              if (value == null || value === '') {
                _this.$message.error(input.data.attrs.placeholder)
                return
              }

              if (confirmInputType === 'number' && parseInt(value) <= -1) {
                _this.$message.error('输入的值不能小于0')
                return
              }
            }
          }
          done()
        }
      }).then(action => {
        if (action === 'confirm') {
          let value = input.elm.value
          let valueNoRequired = componentInstance.$attrs['value-no-required']
          if (!value && !valueNoRequired) {
            return
          }

          let requestUrl = componentInstance.$attrs['requestUrl']
          if (requestUrl) {
            _this.$confirm('确认进行此操作？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(action1 => {
              if (action1 === 'confirm') {
                input.elm.value = ''
                debugger
                let data = componentInstance.$attrs['confirm-input-data']
                let valueAlias = componentInstance.$attrs['value-alias']
                if (valueAlias != null) {
                  data[valueAlias] = value
                } else {
                  data.value = value
                }

                BasicModel.post(_this, requestUrl, data, {
                  success: function (dataInfo) {
                    if (dataInfo.success) {
                      if (componentInstance.$listeners.onInputConfirm) {
                        componentInstance.$listeners.onInputConfirm(value, data)
                      }
                    } else {
                      _this.$message.error(dataInfo.errMsg)
                    }
                  }
                })
              }
            })
          } else {
            if (componentInstance.$listeners.onInputConfirm) {
              componentInstance.$listeners.onInputConfirm(value, data)
            }
          }
        } else {
          input.elm.value = ''
          done()
        }
      }).catch(action => {
        input.elm.value = ''
      })
    }
  }
})
